import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        licences: '<',
        form: '=',
        userId: '<',
        showFulfillingToggle: '='
    },
    template: `
            <div class="row">
                <span class="label">{{ 'licence.Add points to multiple licences' | translate }}</span>
                <div class="items">
                    <label class="switch01">
                        <input
                            type="checkbox"
                            ng-change="vm.toggleMultiple()"
                            ng-model="vm.form.model.addPointsToMultipleLicences"
                            name="switch"
                            ng-readOnly="vm.form.model.isFulfillingPrecondition"
                            ng-disabled="vm.form.model.isFulfillingPrecondition"
                        >
                        <span>{{ 'general.Yes' | translate }}</span>
                    </label>
                </div>
            </div>
            <form-row ng-if="vm.form.model.addPointsToMultipleLicences" error="vm.form.errors.addingType">
                <span class="label">{{ 'licence.Adding type' | translate }}</span>
                <div class="items">
                    <ul class="checkboxes">
                        <li ng-repeat="(value, label) in vm.USER_LICENCE_POINT_ADDING_TYPE_ENUM.LABELS">
                            <label>
                                <input
                                     ng-model="vm.form.model.addingType"
                                     value="{{ value }}"
                                     type="radio"> {{ label }}
                            </label>
                        </li>
                    </ul>
                </div>
                <form-row-error></form-row-error>
            </form-row>
            <div ng-if="!vm.form.model.addPointsToMultipleLicences">
                <form-row error="vm.form.errors['userLicencePoints[0].licenceId']">
                  <label class="label">{{ 'licence.Licence' | translate }} *</label>
                  <div class="items">
                    <select class="form-control"
                            ng-model="vm.form.model.userLicencePoints[0].licenceId"
                            ng-disabled="vm.form.model.userLicencePoints[0].id"
                            ng-change="vm.changeLicenceOnSingleModeAdd()"
                            ng-options="licence.id as licence.name for licence in vm.licences track by licence.id">
                    </select>
                    <form-row-error></form-row-error>
                  </div>
                </form-row>
                <form-row error="vm.form.errors['userLicencePoints[0].licencePeriodId']">
                  <label class="label">{{ 'licence.Licence period' | translate }} *</label>
                  <div class="items">
                    <select class="form-control"
                            ng-model="vm.form.model.userLicencePoints[0].licencePeriodId"
                            ng-disabled="!vm.periods || !vm.periods[0] || vm.form.model.userLicencePoints[0].id"
                            ng-options="period.id as vm.LicenceService.licencePeriodTranslation(period)
                                        for period in vm.periods[0] track by period.id">
                    </select>
                    <form-row-error></form-row-error>
                  </div>
                </form-row>
            </div>
            <form-row ng-if="vm.form.model.addPointsToMultipleLicences" error="vm.form.errors.addPointsToMultipleLicences">
                <form-row-error></form-row-error>
            </form-row>
            <ul ng-if="vm.form.model.addPointsToMultipleLicences" class="items06 type02">
                <li ng-repeat="(index, licence) in vm.form.model.userLicencePoints">
                    <div class="form">
                        <form-row error="vm.form.errors.userLicencePoints[index].licenceId">
                          <label class="label">{{ 'licence.Licence' | translate }} *</label>
                          <div class="items">
                            <select class="form-control"
                                    ng-model="vm.form.model.userLicencePoints[index].licenceId"
                                    ng-disabled="vm.form.model.licences[index].id"
                                    ng-change="vm.queryPeriods(index, vm.form.model.userLicencePoints[index].licenceId)"
                                    ng-options="licence.id as licence.name for licence in vm.licences track by licence.id">
                            </select>
                            <form-row-error></form-row-error>
                          </div>
                        </form-row>
                        <form-row error="vm.form.errors.userLicencePoints[index].licencePeriodId">
                          <label class="label">{{ 'licence.Licence period' | translate }} *</label>
                          <div class="items">
                            <select class="form-control"
                                    ng-model="vm.form.model.userLicencePoints[index].licencePeriodId"
                                    ng-disabled="!vm.periods || !vm.periods[index] || vm.form.model.licences[index].id"
                                    ng-options="period.id as vm.LicenceService.licencePeriodTranslation(period)
                                                for period in vm.periods[index] track by period.id">
                            </select>
                            <form-row-error></form-row-error>
                          </div>
                        </form-row>
                        <ul ng-if="index !== 0" class="actions01">
                            <li><a class="btn delete" ng-click="vm.removeLicenceRow(index)">{{ 'general.Remove' | translate }}</a></li>
                        </ul>
                    </div>
                </li>
            </ul>
            <ul ng-if="vm.form.model.addPointsToMultipleLicences" class="actions01">
                <li><a class="btn add" ng-click="vm.addLicenceRow()">{{ 'general.Add row' | translate }}</a></li>
            </ul>
    `
})
export default class {
    constructor ($rootScope, LicenceService, PrivilegeService, LicencePeriodResource,
                 USER_LICENCE_POINT_ADDING_TYPE_ENUM) {
        this.LicencePeriodResource = LicencePeriodResource;
        this.LicenceService = LicenceService;
        this.PrivilegeService = PrivilegeService;
        this.USER_LICENCE_POINT_ADDING_TYPE_ENUM = USER_LICENCE_POINT_ADDING_TYPE_ENUM;

        $rootScope.$on('reload.licencePeriods', () => {
            this.form.model.userLicencePoints.map((userLicencePoint, index) => {
                if (userLicencePoint.licenceId) {
                    this.queryPeriods(index, userLicencePoint.licenceId);
                    return true;
                }
                return false;
            });
        });
    }

    $onInit () {
        this.form.model.addingType = this.USER_LICENCE_POINT_ADDING_TYPE_ENUM.KEYS.SAME_POINTS_TO_EVERY_LICENCE;
        this.form.model.addPointsToMultipleLicences = false;
        this.periods = [];
        this.form.model.userLicencePoints = [];
        this.addLicenceRow();
    }

    addLicenceRow () {
        this.form.model.userLicencePoints.push({
            licenceId: null,
            licencePeriodId: null
        });
    }

    removeLicenceRow (index) {
        this.form.model.userLicencePoints.splice(index, 1);
        this.periods.splice(index, 1);
    }

    detectFulfillingToggleDisplay () {
        this.showFulfillingToggle = false;
        this.form.model.isFulfillingPrecondition = false;
        const licenceId = parseInt(this.form.model.userLicencePoints[0].licenceId, 10);
        if (licenceId) {
            const selectedLicence = this.licences.filter((licence) => licenceId === licence.id);
            if (selectedLicence[0] && selectedLicence[0].licencePreconditions.length &&
                this.PrivilegeService.canManagePreconditionsOnLicencePoints()) {
                this.showFulfillingToggle = true;
            }
        }
    }

    toggleMultiple () {
        // restore default value if not toggled
        if (!this.form.model.addPointsToMultipleLicences) {
            this.form.model.addingType = this.USER_LICENCE_POINT_ADDING_TYPE_ENUM.KEYS.SAME_POINTS_TO_EVERY_LICENCE;
            // store all added rows to helper variable
            this.filledLicencePoints = this.form.model.userLicencePoints;
            this.form.model.userLicencePoints = [this.form.model.userLicencePoints[0]];
            this.detectFulfillingToggleDisplay();
        }

        if (this.form.model.addPointsToMultipleLicences && this.filledLicencePoints) {
            // restore previously inserted rows
            this.form.model.userLicencePoints = this.filledLicencePoints;
            this.showFulfillingToggle = false;
        }
    }

    changeLicenceOnSingleModeAdd () {
        this.queryPeriods(0, this.form.model.userLicencePoints[0].licenceId);
        this.detectFulfillingToggleDisplay();
    }

    queryPeriods (index, licenceId) {
        this.LicencePeriodResource.query({
            licenceId,
            userId: this.userId,
            isValid: true,
            isPastPeriodAllowed: this.form.model.isPastPeriodAllowed
        }).$promise.then(periods => {
            this.periods[index] = periods;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/user/employee/licencePoints/multipleFormRows/index.js